import { Component, Input } from '@angular/core';
import { ModuleErrorView } from '../errors/module-error.model';

@Component({
    selector: 'app-module-error-banner',
    template: `
    <div *ngIf="error" class="alert alert-danger module-error-banner" role="alert">
      {{ error.message }}
    </div>
  `,
    styles: [
        `
      .module-error-banner {
        margin-bottom: 12px;
      }
    `,
    ],
    standalone: false
})
export class ModuleErrorBannerComponent {
  @Input() error: ModuleErrorView | null = null;
}
